module.exports = __webpack_public_path__ + "static/media/dash-measure-icon.c66fa0a8.svg";